import {FC, useEffect, useState} from "react";
import {Form} from "react-bootstrap";
import {MaybeString} from "../../types/Maybe";

interface Props {
    label: string | React.ReactElement;
    value: MaybeString;
    onChange?: (newValue: string) => void;
    visible?: boolean;
    required?: boolean;
    labelClass?: string;
    fieldClass?: string;
    groupClass?: string;
    formatter?: (value: MaybeString) => string;
}

const StringInputField: FC<Props> = (props) => {
    const [value, setValue] = useState(props.value);

    useEffect(
        () => {
            setValue(props.value);
        }, [props.value]);

    function handleBlur() {
        if (props.onChange) {
            props.onChange(value || "");
        }
    }

    if (props.visible === false) {
        return null
    }

    return (
        <Form.Group className={props.groupClass}>
            {
                props.label &&
                <Form.Label className={props.labelClass}>{props.label}
                    {
                        props.required && <span className={"text-danger"}>*</span>
                    }
                </Form.Label>
            }
            <Form.Control
                required={props.required}
                disabled={!props.onChange}
                className={props.fieldClass}
                value={props.formatter ? props.formatter(value) : (value || "")}
                onChange={event => setValue(event.target.value)}
                onBlur={handleBlur}
            />
        </Form.Group>
    );
}

export default StringInputField;
